module.exports = __webpack_public_path__ + "staticcomp/img/top.6838027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/top.jpg
// module id = vz/p
// module chunks = 39